import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { Plans } from "../../models/products.models";
import { TokensPack } from "../../class/tokensPack.class";

export const ProductsActions = createActionGroup({
    source:'products',
    events:{
        'Load Products': emptyProps(),
        'Add Products': props<{plans:Plans, tokensPacks:TokensPack[]}>(),
    }
})